<template>
  <div class="main-body">
    <div class="header">充值列表</div>
    <div class="out">

      <el-table class="table" size="mini" :data="tableData" :height="th" v-loading="loading"
          ref="table" border stripe>
        <el-table-column prop="elderlyDTO.name" fixed="left" label="姓名" width="100"></el-table-column>
        <el-table-column prop="elderlyDTO.idCard" label="身份证号" width="200"></el-table-column>
        <el-table-column prop="elderlyDTO.userPhone" label="手机号" width="120"></el-table-column>

        <el-table-column prop="elderlyDTO.areaName" label="所属地区" width="200"></el-table-column>
        <el-table-column prop="elderlyDTO.zoneName" label="所属区域" width="300"></el-table-column>

        <el-table-column prop="elderlyDTO.balance" label="余额" width="120"></el-table-column>
        <el-table-column prop="addBalance" label="充值金额" width="120"></el-table-column>
        <el-table-column prop="payMoney" label="付款金额" width="120"></el-table-column>

        <el-table-column prop="createTime" label="充值时间" :formatter="getTime" width="200"></el-table-column>
      </el-table>

      <div class="page">
        <div style="float: left;">共{{ totalItems }}条（{{ Math.ceil(totalItems / pageSize) }}页）</div>
        <div style="float: left;">
          <el-pagination small
              background
              layout="prev, pager, next"
              :total="totalItems"
              :page-size="20"
              :current-page.sync="currentPage"  @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>

  </div>
</template>

<script>

import {timeStr,timefilters,getMonthDay} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";
import elderly from "@/common/status";


export default {
  name: "Role",
  data() {
    return {
      showBatchRecharge:false,
      showNewCardBalance:false,
      loading: false,
      showModalAdd: false,
      batchDialog: false,
      tableData: null,
      batchFileList: [],
      zoneValue: [],
      uploadUrl: this.$shopUrl + 'ImportExcel/RechargeImport',
      uploadData: {
        staffCode: getStaffCode(),
        timeStr: timeStr,
        sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),

      },
      idNumber: '',
      phone: '',
      totalItems: 0,
      pageSize: 20,
      currentPage: 1,
      th: 0,
      name: '',
      isSuccess: '',
      uuid: '',
      timer: '',
      searchData:[],
      searchForm:{
        startTime:'',
        endTime:'',
        name: '',
        phone: ''
      },
    }
  },
  components: {

  },
  created() {
    this.init();
    this.getList();
    this.th = this.$store.state.tableHeight+50;
  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight': function (val) {
      this.th = val+50;
    },
  },
  methods: {
    init() {
      this.searchData=[
        {span:12,name:'老人姓名',value:'name',type:'input'},
        {span:12,name:'手机号',value:'phone',type:'input'},
        {span:24,name:'起止时间',width:495,value:'daterange',type:'slot'},
      ],
          this.searchForm.endTime = getMonthDay('e', 0)
      this.searchForm.startTime = getMonthDay('s', 0)
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "Zone/ListForStaff",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
        }
      }).then((response) => {
        console.log(response);
        if (response.data.error == 0) {
          var data = JSON.stringify(response.data.data);
          data = JSON.parse(data.replace(/"listZoneDTO":\[\],/g, ''))
          this.zoneValue = data;
        } else if (response.data.error == 1) {
          this.$message.error(response.data.message);
        }
      })
    },
    toggleModalAdd: function () {
      this.showModalAdd = !this.showModalAdd;
      this.$refs.myAdd.init();
    },

    getTime(row) {
      return timefilters(row.createTime)
    },


    BatchRecharge() {
      this.showBatchRecharge=!this.showBatchRecharge;
      this.$refs.myBatchRecharge.init();
    },
    NewCardBalanceRecharge() {
      this.showNewCardBalance=!this.showNewCardBalance;
      this.$refs.myNewCardBalance.init();
    },
    closeAdd: function () {
      this.showModalAdd = !this.showModalAdd;
    },
    closeBatchRecharge(){
      this.showBatchRecharge = !this.showBatchRecharge;
    },
    closeNewCardBalance(){
      this.showNewCardBalance = !this.showNewCardBalance;
    },
    current_change: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },

    getAge(row) {
      var identityCard = row.elderlyDTO.idCard;

      var len = (identityCard + "").length;
      if (len == 0) {
        return 0;
      } else {
        if ((len != 15) && (len != 18))//身份证号码只能为15位或18位其它不合法
        {
          return 0;
        }
      }
      var strBirthday = "";
      if (len == 18)//处理18位的身份证号码从号码中得到生日和性别代码
      {
        strBirthday = identityCard.substr(6, 4) + "/" + identityCard.substr(10, 2) + "/" + identityCard.substr(12, 2);
      }
      if (len == 15) {
        strBirthday = "19" + identityCard.substr(6, 2) + "/" + identityCard.substr(8, 2) + "/" + identityCard.substr(10, 2);
      }
      //时间字符串里，必须是“/”
      var birthDate = new Date(strBirthday);
      var nowDateTime = new Date();
      var age = nowDateTime.getFullYear() - birthDate.getFullYear();
      //再考虑月、天的因素;.getMonth()获取的是从0开始的，这里进行比较，不需要加1
      if (nowDateTime.getMonth() < birthDate.getMonth() || (nowDateTime.getMonth() == birthDate.getMonth() && nowDateTime.getDate() < birthDate.getDate())) {
        age--;
      }
      return age;

    },
    dataChange(val){
      this.searchForm.startTime=val[0]
      this.searchForm.endTime=val[1]
    },
    getList() {
      this.loading = true;
      var data={
        timeStr:timeStr,
        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
        staffCode: getStaffCode(),
        pageIndex:this.currentPage,
        pageSize:this.pageSize,
      }
      Object.assign(data,this.searchForm)
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "Recharge/Page",
        data: data
      }).then((response) => {
        console.log(response);
        if (response.data.error == 0) {
          this.loading = false;
          this.tableData = response.data.data.list;
          this.totalItems = response.data.data.total;
          this.$nextTick(()=>{this.$refs.table.doLayout()});
        } else if (response.data.error == 1) {
          this.$message.error(response.data.message);
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    submitUpload() {
      this.loading = true;
      // this.batchDialog=false;
      this.$refs.upload.submit();
      this.crontab();
      // this.getSuccess();
    },
    uploadSuccess(response) {
      // this.$refs.bulkUpload.clearFiles()
      if (response.error === 0) {
        this.batchDialog = false;
        this.uuid = response.data;
        // this.getList()
      } else if (response.error === 1) {
        this.$message.error(response.data.message)
      }
    },

    crontab() {
      this.timer = setInterval(this.getSuccess, 1000 * 2);
    },

    inCrontab() {
      clearInterval(this.timer);
    },

    getSuccess() {
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "ImportExcel/IsSuccess",
        data: {
          uuid: this.uuid
        }
      }).then((response) => {
        console.log(response);
        if (response.data.error === 0) {
          console.log("a-------------" + this.isSuccess);
          this.loading = true;
          this.isSuccess = response.data.data;
          console.log(this.isSuccess);
          if (this.isSuccess === "0") {
            this.loading = true;
          }
          if (this.isSuccess === "1") {
            this.$message({type: 'success', message: '充值成功'});
            this.getList();
            this.inCrontab();
            this.loading = false;

          }
          console.log("b-------------" + this.isSuccess);
          if (this.isSuccess === "2") {
            this.$message({type: 'success', message: '充值失败'});
            this.getList();
            this.inCrontab();
            this.loading = false;
          }
          console.log("c-------------" + this.isSuccess);
          if (this.isSuccess !== "1" && this.isSuccess !== "2" && this.isSuccess !== "0") {
            this.$message({type: 'success', message: this.isSuccess});
            this.getList();
            this.inCrontab();
            this.loading = false;
          }


        } else if (response.data.error === 1) {
          this.$message.error(response.data.message)
        } else if (response.data.error === 2) {
          this.$message({type: 'success', message: '充值失败'});
          this.inCrontab();
          this.loading = false;
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    getTotal(param) {
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (index === 10) {
          sums[index] = this.tableData[0].addBalanceAll;
          return;
        }
        if (index === 11) {
          sums[index] = this.tableData[0].payMoneyAll;
          return;
        }
      });
      return sums;
    },
    closeBatchDialog() {
      this.$refs.upload.clearFiles();
    },
    handleRemove() {

    },

    getTemplate() {
      var that = this
      this.$axios.get(this.$shopUrl + 'Recharge/BatchRechargeImport', {
        responseType: 'blob',
        params: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
        }
      }).then(
          (response) => {
            if (response.data.type == 'application/json') {
              this.$message({type: 'info', message: '系统错误'});
              that.showModal = false;
            } else {
              let fileName = '服务对象批量充值表模板.xlsx';
              that.file(response, fileName);
            }
          }
      )
    },
    file(response, fileName) {
      let blob = new Blob([response.data]);
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, fileName);
      } else {
        let elink = document.createElement("a");
        elink.download = fileName;
        elink.style.display = "none";
        elink.href = URL.createObjectURL(blob)
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href);
        document.body.removeChild(elink);
      }
    },
    politics(row, column, cellValue) {
      return this.allStatus(cellValue, elderly.politicalOutlook);
    },
    marriage(row, column, cellValue) {
      return this.allStatus(cellValue, elderly.maritalValue);
    },
    educations(row, column, cellValue) {
      return this.allStatus(cellValue, elderly.education);
    },
    allStatus(row, status) {
      for (var i in status) {
        if (status[i].value == row) {
          return status[i].label
        }
      }
      return "其它";
    }
  }
}
</script>

<style scoped>

</style>
